import { useIsAdmin } from 'hooks/useIsAdmin'

export const IsAdmin = ({ children }: { children: React.ReactNode }) => {
  const { isAdmin } = useIsAdmin()
  if (isAdmin) {
    return <>{children}</>
  }
  return <></>
}
